import React from 'react';

import styles from './Section.module.scss';

const Section = ({ heading, content }) =>
  content && (
    <div key={heading} className={styles.containerHeading}>
      <div className={styles.heading}>{heading}</div>
      <div className={styles.paragraph}>{content}</div>
    </div>
  );

export default Section;
